import { SVGProps, Ref, forwardRef } from 'react';

export const BookOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.523 4.906C7.4 5.422 9.245 6.06 11.1 6.65v12.817c-1.545-.33-3.098-.616-4.623-1.035-2.702-.744-3.581-1.239-4.004-1.804-.433-.58-.673-1.608-.673-4.484v-4.25c0-1.386.05-2.324.169-2.963.106-.57.167-.664.744-.62.62.046 1.504.236 2.81.595m7.377 14.56c1.545-.329 3.098-.615 4.623-1.035 2.702-.743 3.581-1.238 4.004-1.803.433-.58.673-1.608.673-4.484v-4.25c0-1.386-.05-2.324-.169-2.963-.106-.57-.167-.664-.744-.62-.62.046-1.504.236-2.81.595C16.6 5.422 14.755 6.06 12.9 6.65zM12 5.047C9.742 4.33 7.497 3.544 5.2 2.959.672 1.804 0 2.614 0 7.895v4.249c0 5.577.75 6.58 6 8.023 1.974.543 3.999.905 6 1.333 2.004-.429 4.023-.79 6-1.333 5.25-1.443 6-2.446 6-8.023v-4.25c0-5.576-.75-6.167-6-4.723-2.02.555-4.005 1.242-6 1.876"
                fill="currentColor"
            />
        </g>
    </svg>
));
BookOutlinedSize24Glyph.displayName = 'BookOutlinedSize24Glyph';
